import React from "react";
import { Route } from "react-router-dom";
import {Switch} from "react-router";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/Register/VerifyEmail";
import NotFound from "./pages/NotFound";
import ChooseCar from "./pages/ChooseCar";
import CreateNewCar from "./pages/CreateNewCar";
import OrderAutoBuy from "./pages/OrderAutoBuy";
import ChooseInsuBrand from "./pages/ChooseInsuBrand";
import OrderAutoInfo from "./pages/OrderAutoInfo";
import UpdateCarInfo from "./pages/UpdateCarInfo";
import InsuranceInfo from "./pages/InsuranceInfo";
import EditCarInfo from "./pages/EditCarInfo";
import CarDetail from "./pages/CarDetail";
import ContractDetail from "./pages/ContractDetail";
import RequestClaim from "./pages/RequestClaim";
import CreateClaim from "./pages/CreateClaim";
import ClaimDetail from "./pages/ClaimDetail";
import RenewContract from "./pages/RenewContract";
import RenewContractStep2 from "./pages/RenewContractStep2";
import CompleteOrder from "./pages/CompleteOrder";
import OrderDetail from "./pages/OrderDetail";
import Support from "./pages/Support";
import OpenCamera from "./pages/OpenCamera";
import ChangePassword from "./pages/ChangePassword";
import User from "./pages/User";
import UpdateUserInfo from "./pages/UpdateUserInfo";
import RequireLogin from "./components/RequireLogin";
import { messaging } from "./init-fcm";

export default class Routes extends React.Component {
    async componentDidMount() {
        console.log('component did mount on RequireLogin');

        messaging.requestPermission()
          .then(async function() {
            const token = await messaging.getToken();
            global.deviceToken = token
            console.log('device fcm token = ' + token)
          })
          .catch(function(err) {
            console.log("Unable to get permission to notify.", err);
          });
        navigator.serviceWorker.addEventListener("message", (message) => console.log(message));

    }

    render() {
        return (
            <Switch>
                <RequireLogin exact path="/"  component={Home} />
                <RequireLogin exact path="/home"  component={Home} />
                <RequireLogin exact path="/support"  component={Support} />
                <RequireLogin exact path="/user"  component={User} />
                <RequireLogin exact path="/chon-xe-mua-bao-hiem"  component={ChooseCar} />
                <RequireLogin exact path="/them-xe-moi"  component={CreateNewCar} />
                <RequireLogin exact path="/update-thong-tin-xe"  component={UpdateCarInfo} />
                <RequireLogin exact path="/cap-nhat-thong-tin-xe"  component={EditCarInfo} />
                <RequireLogin exact path="/chi-tiet-xe"  component={CarDetail} />
                <RequireLogin exact path="/mua-bao-hiem"  component={OrderAutoBuy} />
                <RequireLogin exact path="/chon-hang-bao-hiem"  component={ChooseInsuBrand} />
                <RequireLogin exact path="/thong-tin-nguoi-mua"  component={OrderAutoInfo} />
                <RequireLogin exact path="/hoan-thien-ho-so"  component={CompleteOrder} />
                <RequireLogin exact path="/chi-tiet-don-hang"  component={OrderDetail} />
                <RequireLogin exact path="/open-camera"  component={OpenCamera} />
                <RequireLogin exact path="/doi-mat-khau"  component={ChangePassword} />
                <RequireLogin exact path="/cap-nhat-thong-tin"  component={UpdateUserInfo} />
                <RequireLogin exact path="/thong-tin-bao-hiem"  component={InsuranceInfo} />
                <RequireLogin exact path="/chi-tiet-hop-dong"  component={ContractDetail} />
                <RequireLogin exact path="/yeu-cau-boi-thuong"  component={RequestClaim} />
                <RequireLogin exact path="/chi-tiet-khieu-nai"  component={ClaimDetail} />
                <RequireLogin exact path="/tao-yeu-cau-boi-thuong"  component={CreateClaim} />
                <RequireLogin exact path="/gia-han-hop-dong"  component={RenewContract} />
                <RequireLogin exact path="/gia-han-hop-dong-buoc-2"  component={RenewContractStep2} />
                <Route exact path="/login"  component={Login} />
                <Route exact path="/register"  component={Register} />
                <Route exact path="/forgot-password"  component={ForgotPassword} />
                <Route exact path="/reset-mat-khau"  component={ResetPassword} />
                <Route exact path="/register/verify-email"  component={VerifyEmail} />
                <Route path="*" component={NotFound} />
            </Switch>
        );
    }
}